import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_text_component_viewer = _resolveComponent("text-component-viewer")!
  const _component_image_component_viewer = _resolveComponent("image-component-viewer")!
  const _component_qr_printer = _resolveComponent("qr-printer")!
  const _component_qr_field_component_viewer = _resolveComponent("qr-field-component-viewer")!

  return (_openBlock(), _createElementBlock("div", {
    class: "template-viewer-wrapper",
    style: _normalizeStyle(_ctx.wrapperStyle)
  }, [
    (_ctx.template && _ctx.qrConfig)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "template-viewer",
          style: _normalizeStyle({
                 width: _ctx.template.width + 'px',
                 height: _ctx.template.height + 'px',
                 borderRadius: _ctx.template.borderRadius,
                 backgroundColor: _ctx.template.backgroundColor,
                 transform: 'scale(' + _ctx.scale + ')'
             })
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.template.components as any[], (component, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "page-component",
              style: _normalizeStyle({
                     left: component.x + 'px',
                     top: component.y + 'px',
                     width: component.width || component.size + 'px',
                     height: component.height || component.size + 'px'
                 })
            }, [
              (component.type === 'TextComponent')
                ? (_openBlock(), _createBlock(_component_text_component_viewer, {
                    key: 0,
                    item: component
                  }, null, 8, ["item"]))
                : _createCommentVNode("", true),
              (component.type === 'ImageComponent')
                ? (_openBlock(), _createBlock(_component_image_component_viewer, {
                    key: 1,
                    item: component
                  }, null, 8, ["item"]))
                : _createCommentVNode("", true),
              (component.type === 'QrCodeComponent')
                ? (_openBlock(), _createBlock(_component_qr_printer, {
                    key: 2,
                    identifier: _ctx.qrConfig.identifier,
                    class: "qr-fill"
                  }, null, 8, ["identifier"]))
                : _createCommentVNode("", true),
              (component.type === 'QrFieldComponent')
                ? (_openBlock(), _createBlock(_component_qr_field_component_viewer, {
                    key: 3,
                    item: component,
                    qrConfig: _ctx.qrConfig
                  }, null, 8, ["item", "qrConfig"]))
                : _createCommentVNode("", true)
            ], 4))
          }), 128))
        ], 4))
      : _createCommentVNode("", true)
  ], 4))
}